import React from 'react';

const StatCard = ({ 
  title, 
  value, 
  change, 
  changeType = 'positive', 
  icon, 
  subtitle,
  trend,
  color = 'blue' 
}) => {
  const colorClasses = {
    blue: 'bg-blue-50 border-blue-200 text-blue-600',
    green: 'bg-green-50 border-green-200 text-green-600',
    purple: 'bg-purple-50 border-purple-200 text-purple-600',
    yellow: 'bg-yellow-50 border-yellow-200 text-yellow-600',
    red: 'bg-red-50 border-red-200 text-red-600',
    indigo: 'bg-indigo-50 border-indigo-200 text-indigo-600'
  };

  const changeColorClasses = {
    positive: 'text-green-600 bg-green-100',
    negative: 'text-red-600 bg-red-100',
    neutral: 'text-gray-600 bg-gray-100'
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 sm:p-6 hover:shadow-md transition-shadow duration-200">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-2 sm:space-x-3">
            {icon && (
              <div className={`p-1.5 sm:p-2 rounded-lg ${colorClasses[color]} flex-shrink-0`}>
                {icon}
              </div>
            )}
            <div className="min-w-0 flex-1">
              <p className="text-xs sm:text-sm font-medium text-gray-600 truncate">{title}</p>
              <p className="text-xl sm:text-2xl font-bold text-gray-900">{value}</p>
            </div>
          </div>
          
          {subtitle && (
            <p className="text-xs sm:text-sm text-gray-500 mt-1">{subtitle}</p>
          )}
        </div>

        <div className="flex flex-col items-end space-y-1 sm:space-y-2 ml-2 flex-shrink-0">
          {change && (
            <div className={`px-2 py-1 rounded-full text-xs font-medium ${changeColorClasses[changeType]}`}>
              {changeType === 'positive' ? '+' : changeType === 'negative' ? '-' : ''}{change}
            </div>
          )}
          
          {trend && (
            <div className="text-xs text-gray-400 text-right">
              {trend}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
